import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "./contextProvider/ContextProvider";

/**
 * IMPORTANT - This is for Testing only - this component will only load when NODE_ENV !== "production"
 * Take a username and student number to store in Context and redirect to the student's echeckin page
 * @name LoadTest
 * @constructor
 * @return {JSX.Element}
 */
const LoadTestStudentNumber = () => {
    const { userName, number } = useParams();

    const navigate = useNavigate();

    const { dispatch, state } = useContext(GlobalContext);
    const { username, studentNumber } = state || {};

    /**
     * set username in context
     */
    useEffect(() => {
        if (userName && !username) {
            dispatch({
                type: "Username",
                username: userName
            });
            sessionStorage.setItem("uname", userName);
        }
    }, [dispatch, userName, username]);

    /**
     * set studentnumber in context
     */
    useEffect(() => {
        if (number && !studentNumber) {
            dispatch({
                type: "StudentNumber",
                studentNumber: number
            });
        }
    }, [dispatch, number, studentNumber]);

    /**
     * when they are set go to the correct route
     */
    useEffect(() => {
        if (username && studentNumber) {
            navigate(`/view/${studentNumber}`);
        }
    }, [navigate, username, studentNumber]);

    return (
        <div>
            <h2>Welcome to the Load Tester - setting values for STUDENT NUMBER...</h2>
        </div>
    );
};

export default LoadTestStudentNumber;
